import React from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Link as RouterLink } from "react-router-dom";
import { getPageRoute } from "src/services";

/**
 * Centered CTA button that appears at the bottom of every homepage section
 * and routes to the standalone `/waitlist` page.
 */
const WaitlistCTA = ({ variant = "light" }) => {
  const theme = useTheme();

  const isDark = variant === "dark";
  const bg = isDark
    ? theme.palette.success.main
    : theme.palette.text.primary;
  const bgHover = isDark ? "#15803d" : theme.palette.gray?.[900] || "#1a1a1a";

  return (
    <Box sx={{ mt: { xs: 6, md: 8 }, textAlign: "center" }}>
      <Button
        component={RouterLink}
        to={getPageRoute("waitlist", "WAITLIST")}
        sx={{
          bgcolor: bg,
          color: theme.palette.paper.primary,
          px: { xs: 4.5, md: 5.5 },
          py: { xs: 2, md: 2.5 },
          fontSize: { xs: "1rem", md: "1.125rem" },
          fontWeight: 700,
          textTransform: "none",
          borderRadius: 999,
          letterSpacing: "-0.005em",
          boxShadow: isDark
            ? "0 8px 24px rgba(32,156,51,0.35)"
            : "0 8px 24px rgba(0,0,0,0.15)",
          "&:hover": {
            bgcolor: bgHover,
            transform: "translateY(-2px)",
            boxShadow: isDark
              ? "0 10px 28px rgba(32,156,51,0.45)"
              : "0 10px 28px rgba(0,0,0,0.2)",
          },
          transition: "transform 0.15s, background-color 0.15s, box-shadow 0.15s",
        }}
      >
        Join the waitlist →
      </Button>
    </Box>
  );
};

export default WaitlistCTA;
